(() => {
 'use strict';
 const controlSelector='a,button,[role="button"]', arrows=/[\u2190-\u21ff\u2794\u2798-\u27be]/g;
 const ar=document.documentElement.lang.startsWith('ar');
 function clean(control){
  if(control.closest('.shopify-payment-button,shopify-accelerated-checkout'))return;
  const carousel=control.classList.contains('flickityt4s-prev-next-button');
  if(carousel&&!control.querySelector('.ww-navigation-label')){
   const label=document.createElement('span');label.className='ww-navigation-label';
   label.textContent=control.classList.contains('previous')?(ar?'السابق':'Prev'):(ar?'التالي':'Next');
   control.append(label);control.setAttribute('aria-label',label.textContent);
  }
  const walk=document.createTreeWalker(control,NodeFilter.SHOW_TEXT);
  while(walk.nextNode()){
   const node=walk.currentNode;
   if(node.parentElement?.closest('svg,script,style'))continue;
   const next=node.nodeValue.replace(arrows,'');
   if(next!==node.nodeValue)node.nodeValue=next;
  }
  control.querySelectorAll('[class*="icon-arrow"],[class*="chevron"],[class*="la-angle-"]').forEach(icon=>icon.classList.add('ww-hidden-arrow'));
  control.querySelectorAll('svg').forEach(svg=>{
   const uses=[...svg.querySelectorAll('use')].map(x=>x.getAttribute('href')||x.getAttribute('xlink:href')||'').join(' ');
   const identity=[svg.getAttribute('class')||'',svg.id,uses].join(' ');
   if(carousel||/arrow|chevron|caret/i.test(identity))svg.classList.add('ww-hidden-arrow');
  });
 }
 function scan(root){
  if(!(root instanceof Element)&&root!==document)return;
  if(root instanceof Element){const parent=root.closest(controlSelector);if(parent)clean(parent);}
  root.querySelectorAll(controlSelector).forEach(clean);
 }
 scan(document);
 new MutationObserver(records=>{
  const roots=new Set();
  for(const record of records){
   if(record.type==='characterData'){const control=record.target.parentElement?.closest(controlSelector);if(control)roots.add(control);}
   else for(const node of record.addedNodes)if(node instanceof Element)roots.add(node);
  }
  roots.forEach(scan);
 }).observe(document.body,{childList:true,subtree:true,characterData:true});
})();

(() => {
 'use strict';
 const selector=".ww-button,.ww-review-cta,.ww-cta,.t4s-btn:is(.t4s-btn-color-primary,.t4s-btn-color-dark):not(.t4s-btn-style-outline,.t4s-btn-style-bordered,.t4s-btn-style-bordered_top,.t4s-btn-style-link),.t4s-pr__notify-stock:is(.t4s-btn-color-primary,.t4s-btn-color-dark),.t4s-sticky-atc__atc,[data-ww-action]";
 const candidates=selector+',button,input[type="submit"],input[type="button"],input[type="reset"],[role="button"]';
 const controls=new Set(),pending=new Set(),widths=new WeakMap();
 let frame=0,dockTimer=0,lastDock=-1;
 function rgba(value){
  const match=/^rgba?\(([^)]+)\)$/i.exec(value||'');
  if(!match)return null;
  const values=match[1].replace(/\//g,',').split(/[,\s]+/).filter(Boolean).map(Number);
  if(values.length<3||values.some(x=>!Number.isFinite(x)))return null;
  return [values[0],values[1],values[2],values.length>3?values[3]:1];
 }
 function isGold(value){
  const color=rgba(value);
  return !!color&&color[3]>.85&&[[255,176,0],[251,176,0],[146,107,17]].some(rgb=>rgb.every((v,i)=>Math.abs(v-color[i])<2));
 }
 function compactHeight(height){return Math.max(40,Math.round(height*.8*100)/100);}
 function excluded(control){return !!control.closest('.shopify-payment-button,shopify-accelerated-checkout,.ww-buy-now-offer,#whatsapp-start,#ww-offer-dialog');}
 function fixedHeight(control){
  return control.matches('.t4s-product-form__submit,.t4s-sticky-atc__atc,.t4s-btn__cart,.t4s-btn__checkout,.t4s-btn__update,.ww-review-cta,[data-show-more],[data-full-catalog]');
 }
 function size(control){
  if(!control.isConnected||excluded(control))return;
  control.removeAttribute('data-ww-action-sized');
  const rect=control.getBoundingClientRect();
  widths.set(control,rect.width);
  if(!rect.width||!rect.height||fixedHeight(control))return;
  control.style.setProperty('--ww-action-height',compactHeight(rect.height)+'px');
  control.setAttribute('data-ww-action-sized','');
 }
 function obstruction(viewport,rects){
  let occupied=0;
  for(const rect of rects)if(rect.height>0&&rect.top<viewport&&rect.bottom>0)occupied=Math.max(occupied,viewport-Math.max(0,rect.top));
  return Math.round(occupied*100)/100;
 }
 function dock(){
  if(!window.matchMedia('(max-width:1024px)').matches)return;
  const rects=[];
  document.querySelectorAll('.t4s-toolbar,.t4s-sticky-atc').forEach(node=>{
   const style=getComputedStyle(node);
   if(style.display!=='none'&&style.visibility!=='hidden'&&Number(style.opacity)!==0)rects.push(node.getBoundingClientRect());
  });
  const height=obstruction(window.innerHeight,rects);
  if(height!==lastDock){lastDock=height;document.documentElement.style.setProperty('--ww-bottom-obstruction',height+'px');}
 }
 function schedule(control){
  if(control)pending.add(control);
  if(!frame)frame=requestAnimationFrame(()=>{
   frame=0;for(const item of pending)size(item);pending.clear();dock();
  });
 }
 const resize='ResizeObserver'in window?new ResizeObserver(entries=>{
  for(const entry of entries)if(widths.get(entry.target)!==entry.target.getBoundingClientRect().width)schedule(entry.target);
 }):null;
 function track(control){
  if(excluded(control)||(!control.matches(selector)&&!isGold(getComputedStyle(control).backgroundColor)))return;
  control.setAttribute('data-ww-action','');
  if(!controls.has(control)){controls.add(control);if(resize)resize.observe(control);}
  schedule(control);
 }
 function scan(root){
  if(!(root instanceof Element)&&root!==document)return;
  if(root instanceof Element){if(root.matches(candidates))track(root);const parent=root.closest('[data-ww-action]');if(parent)schedule(parent);}
  root.querySelectorAll(candidates).forEach(track);
 }
 function refresh(){
  for(const control of controls)if(control.isConnected)schedule(control);else{controls.delete(control);if(resize)resize.unobserve(control);}
  scan(document);schedule();
 }
 scan(document);
 new MutationObserver(records=>{
  for(const record of records){
   if(record.target instanceof Element){const parent=record.target.closest('[data-ww-action]');if(parent)schedule(parent);}
   for(const node of record.addedNodes)if(node instanceof Element)scan(node);
  }
 }).observe(document.body,{childList:true,subtree:true});
 new MutationObserver(()=>{
  schedule();clearTimeout(dockTimer);dockTimer=setTimeout(()=>schedule(),350);
 }).observe(document.body,{attributes:true,attributeFilter:['class']});
 window.addEventListener('resize',refresh,{passive:true});
 window.addEventListener('scroll',()=>schedule(),{passive:true});
 window.addEventListener('load',refresh,{once:true});
 document.addEventListener('shopify:section:load',event=>scan(event.target));
 if(document.fonts)document.fonts.ready.then(refresh);
 schedule();
})();

(() => {
 if(!document.body.classList.contains('template-product'))return;
 const update=()=>document.body.classList.toggle('ww-header-at-top',window.scrollY<=1);
 update();window.addEventListener('scroll',update,{passive:true});window.addEventListener('pageshow',update);
})();
